<script lang="ts">
	import { getOptimizedCmsImageUrl } from '../../../utils/cms';
	import { viewport } from '$lib/stores/viewport';
	import AdaptiveImage from '$lib/components/AdaptiveImage.svelte';
	import AdaptiveVideo from '$lib/modules/AdaptiveVideo.svelte';
	import ButtonSVG from '$lib/elements/buttons/variants/ButtonSVG.svelte';

	export let title;
	export let image;
	export let classNames;
	export let article;

	const getAdaptiveImagesData = (filename: string, alt: string): Record<string, any> => {
		return {
			sources: [
				{
					srcset: `${getOptimizedCmsImageUrl(filename, '800x800')} 800w, ${getOptimizedCmsImageUrl(
						filename,
						'1550x650'
					)} 1550w`
				}
			],
			img: getOptimizedCmsImageUrl(filename, '1550x650'),
			alt: alt ? alt : 'wiseed'
		};
	};
</script>

{#if !$viewport.isDesktop}
	<div
		class=" {article?.content?.videoId
			? ''
			: 'absolute right-2/4 translate-x-1/2'} z-10 pt-3 lg:pb-0"
	>
		<ButtonSVG
			props={{
				href: '/blog',
				classNames: 'block text-primary lg:hidden flex-shrink-0',
				iconClassNames: '!w-[200px] !h-[53px] mx-auto',
				name: 'logo_wiiiblog'
			}}
		/>
	</div>
{/if}
{#if article?.content?.videoId}
	<div class="flex mt-3 md:mt-5 lg:mt-7 items-center justify-center border-b-4 border-primary">
		<AdaptiveVideo
			src={`https://www.youtube.com/embed/${article.content?.videoId}`}
			iframeTitle
			iframe
			ratio={!$viewport.isDesktop ? 'aspect-video' : ''}
			classNames={' lg:!h-[650px]  w-full'}
		/>
	</div>
{:else}
	<div
		class="relative h-[100vh] md:h-[70vh] lg:h-[80vh] flex items-center justify-center {classNames}"
	>
		{#if image?.filename}
			<div class="absolute inset-0">
				<AdaptiveImage
					src={getAdaptiveImagesData(image?.filename, image?.alt)}
					classNames="object-cover w-full h-full"
					isLazyLoaded={false}
				/>
			</div>
		{/if}
		<div class="relative {image?.filename ? 'text-white' : ''}">
			{#if title?.length}
				<h1>{@html title}</h1>
			{/if}
		</div>
	</div>
{/if}
